// Country -> dial code + primary IANA timezone.
// One primary timezone per country (multi-timezone countries such as the US,
// Russia, Australia use their most common/capital-region zone — a documented
// simplification for Phase 1).
//
// Kept in sync with frontend/src/data/countries.js (duplicated intentionally:
// api/ and frontend/ are separate npm packages with no shared workspace).

export const COUNTRIES = [
  { name: 'Australia', iso2: 'AU', dialCode: '+61', timezone: 'Australia/Sydney' },
  { name: 'Austria', iso2: 'AT', dialCode: '+43', timezone: 'Europe/Vienna' },
  { name: 'Bangladesh', iso2: 'BD', dialCode: '+880', timezone: 'Asia/Dhaka' },
  { name: 'Belgium', iso2: 'BE', dialCode: '+32', timezone: 'Europe/Brussels' },
  { name: 'Brazil', iso2: 'BR', dialCode: '+55', timezone: 'America/Sao_Paulo' },
  { name: 'Brunei', iso2: 'BN', dialCode: '+673', timezone: 'Asia/Brunei' },
  { name: 'Cambodia', iso2: 'KH', dialCode: '+855', timezone: 'Asia/Phnom_Penh' },
  { name: 'Canada', iso2: 'CA', dialCode: '+1', timezone: 'America/Toronto' },
  { name: 'Chile', iso2: 'CL', dialCode: '+56', timezone: 'America/Santiago' },
  { name: 'China', iso2: 'CN', dialCode: '+86', timezone: 'Asia/Shanghai' },
  { name: 'Colombia', iso2: 'CO', dialCode: '+57', timezone: 'America/Bogota' },
  { name: 'Denmark', iso2: 'DK', dialCode: '+45', timezone: 'Europe/Copenhagen' },
  { name: 'Egypt', iso2: 'EG', dialCode: '+20', timezone: 'Africa/Cairo' },
  { name: 'Finland', iso2: 'FI', dialCode: '+358', timezone: 'Europe/Helsinki' },
  { name: 'France', iso2: 'FR', dialCode: '+33', timezone: 'Europe/Paris' },
  { name: 'Germany', iso2: 'DE', dialCode: '+49', timezone: 'Europe/Berlin' },
  { name: 'Greece', iso2: 'GR', dialCode: '+30', timezone: 'Europe/Athens' },
  { name: 'Hong Kong', iso2: 'HK', dialCode: '+852', timezone: 'Asia/Hong_Kong' },
  { name: 'India', iso2: 'IN', dialCode: '+91', timezone: 'Asia/Kolkata' },
  { name: 'Indonesia', iso2: 'ID', dialCode: '+62', timezone: 'Asia/Jakarta' },
  { name: 'Ireland', iso2: 'IE', dialCode: '+353', timezone: 'Europe/Dublin' },
  { name: 'Israel', iso2: 'IL', dialCode: '+972', timezone: 'Asia/Jerusalem' },
  { name: 'Italy', iso2: 'IT', dialCode: '+39', timezone: 'Europe/Rome' },
  { name: 'Japan', iso2: 'JP', dialCode: '+81', timezone: 'Asia/Tokyo' },
  { name: 'Laos', iso2: 'LA', dialCode: '+856', timezone: 'Asia/Vientiane' },
  { name: 'Macau', iso2: 'MO', dialCode: '+853', timezone: 'Asia/Macau' },
  { name: 'Malaysia', iso2: 'MY', dialCode: '+60', timezone: 'Asia/Kuala_Lumpur' },
  { name: 'Mexico', iso2: 'MX', dialCode: '+52', timezone: 'America/Mexico_City' },
  { name: 'Myanmar', iso2: 'MM', dialCode: '+95', timezone: 'Asia/Yangon' },
  { name: 'Nepal', iso2: 'NP', dialCode: '+977', timezone: 'Asia/Kathmandu' },
  { name: 'Netherlands', iso2: 'NL', dialCode: '+31', timezone: 'Europe/Amsterdam' },
  { name: 'New Zealand', iso2: 'NZ', dialCode: '+64', timezone: 'Pacific/Auckland' },
  { name: 'Norway', iso2: 'NO', dialCode: '+47', timezone: 'Europe/Oslo' },
  { name: 'Pakistan', iso2: 'PK', dialCode: '+92', timezone: 'Asia/Karachi' },
  { name: 'Philippines', iso2: 'PH', dialCode: '+63', timezone: 'Asia/Manila' },
  { name: 'Poland', iso2: 'PL', dialCode: '+48', timezone: 'Europe/Warsaw' },
  { name: 'Portugal', iso2: 'PT', dialCode: '+351', timezone: 'Europe/Lisbon' },
  { name: 'Qatar', iso2: 'QA', dialCode: '+974', timezone: 'Asia/Qatar' },
  { name: 'Saudi Arabia', iso2: 'SA', dialCode: '+966', timezone: 'Asia/Riyadh' },
  { name: 'Singapore', iso2: 'SG', dialCode: '+65', timezone: 'Asia/Singapore' },
  { name: 'South Africa', iso2: 'ZA', dialCode: '+27', timezone: 'Africa/Johannesburg' },
  { name: 'South Korea', iso2: 'KR', dialCode: '+82', timezone: 'Asia/Seoul' },
  { name: 'Spain', iso2: 'ES', dialCode: '+34', timezone: 'Europe/Madrid' },
  { name: 'Sri Lanka', iso2: 'LK', dialCode: '+94', timezone: 'Asia/Colombo' },
  { name: 'Sweden', iso2: 'SE', dialCode: '+46', timezone: 'Europe/Stockholm' },
  { name: 'Switzerland', iso2: 'CH', dialCode: '+41', timezone: 'Europe/Zurich' },
  { name: 'Taiwan', iso2: 'TW', dialCode: '+886', timezone: 'Asia/Taipei' },
  { name: 'Thailand', iso2: 'TH', dialCode: '+66', timezone: 'Asia/Bangkok' },
  { name: 'Turkey', iso2: 'TR', dialCode: '+90', timezone: 'Europe/Istanbul' },
  { name: 'United Arab Emirates', iso2: 'AE', dialCode: '+971', timezone: 'Asia/Dubai' },
  { name: 'United Kingdom', iso2: 'GB', dialCode: '+44', timezone: 'Europe/London' },
  { name: 'United States', iso2: 'US', dialCode: '+1', timezone: 'America/New_York' },
  { name: 'Vietnam', iso2: 'VN', dialCode: '+84', timezone: 'Asia/Ho_Chi_Minh' },
];

export function findCountry(name) {
  return COUNTRIES.find((c) => c.name === name) || null;
}

export function timezoneForCountry(name, fallback = 'UTC') {
  const c = findCountry(name);
  return c ? c.timezone : fallback;
}
